import { Bar } from '../BaseCharts'
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'

export default {
  extends: Bar,
  data: function() {
    return {
      pendingCount: '',
      deliveredCount: '',
    }
  },
  created: function() {
    this.getPendingCount()
  },
  mounted () {
  },

  methods: {
    getPendingCount: function() {
       this.$http.post(`${CONSTANTS.API_URL}/P2PReports/GetDashboardBarChartData`)
        .then((response) => {
          if (response) {
            var result = JSON.parse(response.bodyText);
            this.pendingCount = parseInt(result.returnvalue[0].pickcnt);
            this.deliveredCount = parseInt(result.returnvalue[0].delcnt);
            let self = this;
            this.renderChart({
              labels: ['Pickup', 'Delivery'],
              datasets: [
                {
                  label: 'Location ID Not Assigned',
                  backgroundColor : [ "#00BFFF", "#ff69b4"],
                  data: [this.pendingCount, this.deliveredCount]
                }
              ]
            },
            {  responsive: true,
               scales: {
                   yAxes: [{
                       display: true,
                       ticks: {
                           beginAtZero: true,
                           max: 30,
                           min: 0,
                           stepSize:5
                       }
                   }]
               },
               onClick: function(evt){
                 var activePoint = this.getElementAtEvent(evt)[0];
                 var data = activePoint._chart.data;
                 var statusValue = data.labels[activePoint._index];
                 if(statusValue == "Pickup")
                 {
                    self.$router.push('picknotassignedShipments');
                 }else {
                    self.$router.push('delnotassignedShipments');
                 }
               }
            })
          } else {
            alert('Data not found')
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    }
  }
}
